import { Injectable, } from '@angular/core';
import { Http, Headers, URLSearchParams, Response, HttpModule, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class FleetService {

  base_url: string;
  constructor(
    public http: HttpClient,
  ) {
    this.base_url = environment.appUrl + "/fleets";
  }

  getFleetByVehicleLicenseNumber(vehicleLicenseNumber): Observable<any>{  
    console.log(vehicleLicenseNumber);
    //change post url next to base_url 
    return this.http.get(this.base_url + '/licenseNumber' + '/' + vehicleLicenseNumber.licenseNumber);
  }

  getallFleets(): Observable<any> {
    //change post url next to base_url 
    return this.http.get(this.base_url);
  }

  getActiveFleets(): Observable<any> {
    //change post url next to base_url 
    return this.http.get(this.base_url + "/activefleets");
  }
  
  getAllFleetsByType(type): Observable<any> {
   //change post url next to base_url 
    return this.http.get(this.base_url + "/type/" + type);
  }

  getAllFleetsByTypeAndStatus(type): Observable<any> {
    return this.http.get(this.base_url + "/available?type=" + type);
  }

  addFleet(newFleet): Observable<any> { 
    JSON.stringify(newFleet);

    console.log(newFleet);
    //change post url next to base_url 
    return this.http.post(this.base_url, newFleet);
  }

  updateFleet(updatedFleet): Observable<any> {
    //change post url next to base_url 
    return this.http.put(this.base_url, updatedFleet);
  }

  ActivateFleet(f, bActivate): Observable<any> {
    //change post url next to base_url 
    return this.http.patch(this.base_url + '/licenseNumber' + '/' + f + '/' + bActivate, null);
  }

  getAllFleetsByStatus(fleetStatus: String): Observable<any> {
    //change post url next to base_url 
    return this.http.get(this.base_url + '/status/' + fleetStatus);
  }

  getFleetCountByStatus(): Observable<any> {
    //change post url next to base_url 
    return this.http.get(this.base_url + '/status/count');
  }

  getAllAvailabilityForAllFleets(): Observable<any> {
    //change post url next to base_url 
    return this.http.get(this.base_url + '/availability');
  }

  addFleetAvailability(newFleetAvailability): Observable<any> {
    console.log(newFleetAvailability);
    //change post url next to base_url 
    return this.http.post(this.base_url + '/availability', newFleetAvailability);
  }

  assignPreferredDriverToFleet(licenseNumber, resource): Observable<any> {
    //change post url next to base_url 
    return this.http.put(this.base_url + '/licenseNumber/' + licenseNumber  + '/preferreddriver', resource);
  }
}